module.exports = __webpack_public_path__ + "img/Chestnut_Icon.eb16ce9a.png";